import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'vi',
  months: [
    'tháng Một',
    'tháng Hai',
    'tháng Ba',
    'tháng Tư',
    'tháng Năm',
    'tháng Sáu',
    'tháng Bảy',
    'tháng Tám',
    'tháng Chín',
    'tháng Mười',
    'tháng Mười Một',
    'tháng Mười Hai',
  ],
  monthsShort: [
    'tháng 1',
    'tháng 2',
    'tháng 3',
    'tháng 4',
    'tháng 5',
    'tháng 6',
    'tháng 7',
    'tháng 8',
    'tháng 9',
    'tháng 10',
    'tháng 11',
    'tháng 12',
  ],
  weekdays: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
  weekdaysMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  weekdaysShort: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'H:mm D MMMM, YYYY ([GMT]Z)',
  },
  meridiem: { am: 'SA', pm: 'CH', AM: 'SA', PM: 'CH' },
  past: {
    y: { other: '%s năm trước' },
    M: { other: '%s tháng trước' },
    w: { other: '%s tuần trước' },
    d: { other: '%s ngày trước' },
    h: { other: '%s giờ trước' },
    m: { other: '%s phút trước' },
    s: { other: '%s giây trước' },
  },
  future: {
    y: { other: 'sau %s năm nữa' },
    M: { other: 'sau %s tháng nữa' },
    w: { other: 'sau %s tuần nữa' },
    d: { other: 'sau %s ngày nữa' },
    h: { other: 'sau %s giờ nữa' },
    m: { other: 'sau %s phút nữa' },
    s: { other: 'sau %s giây nữa' },
  },
  abbr: {
    y: { other: '%s năm' },
    M: { other: '%s tháng' },
    w: { other: '%s tuần' },
    d: { other: '%s ngày' },
    h: { other: '%s giờ' },
    m: { other: '%s phút' },
    s: { other: '%s giây' },
  },
  justNow: 'Vừa xong',
  yesterday: 'Hôm qua',
  today: 'Hôm nay',
  tomorrow: 'Ngày mai',
  weekStart: 1,
};
const localeName: LocaleName = 'vi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'SA' : 'SA';
    } else {
      return isLowerCase ? 'CH' : 'CH';
    }
  },
};
